/** Customer emails that came back to a reply address we couldn't match
 *  (spec 2026-10-02). Normally empty; anything here needs a person. */
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import { InboundBlock } from '../components/InboundBlock'
import type { InboundMessage } from '../lib/replies'

export function UnthreadedRepliesPage() {
  const q = useQuery({
    queryKey: ['inbound-unthreaded'],
    queryFn: () => api.get<{ items: InboundMessage[]; count_30d: number }>('/api/inbound/unthreaded'),
  })
  return (
    <div className="p-8 space-y-6 max-w-[1200px]">
      <header className="border-b border-ink-500 pb-6">
        <div className="label mb-1">Members · inbound</div>
        <h1 className="font-serif text-[42px] leading-[1.05] tracking-tight text-paper">Unthreaded answers</h1>
        <p className="mt-2 text-sm text-paper-dim max-w-[62ch]">
          Emails sent to a reply address that doesn't match any reply we sent. Answer them from service@.
        </p>
        <Link to="/help/reply-desk" className="label hover:underline self-end whitespace-nowrap">Reply desk guide</Link>
      </header>
      {q.isLoading && <p className="text-paper-trace">Loading…</p>}
      {q.isError && <p className="text-red-400">Couldn't load. Try again.</p>}
      {q.data && q.data.items.length === 0 && <p className="text-paper-trace">Nothing here.</p>}
      <ul className="space-y-4">
        {q.data?.items.map((i) => (
          <li key={i.id} className="border border-ink-500 rounded-sm p-4">
            <p className="text-sm text-paper-trace mb-2">{i.subject ?? '(no subject)'} · {i.from_email}</p>
            <InboundBlock item={i} />
          </li>
        ))}
      </ul>
    </div>
  )
}
